import { GraphQLError } from 'graphql';
import { graphql } from 'msw';

import { SigninUserMutation } from '../AuthModal/section/SignIn/queries/signIn.generated';
import { generateUserHandler } from './user';

export const generateSignInHandler = (
    response: SigninUserMutation['signinUser']
) => {
    return graphql.mutation<SigninUserMutation>('signinUser', (_, res, ctx) => {
        return res(ctx.data({ signinUser: response }));
    });
};

export const generateSignInErrorHandler = (
    errorMessage: GraphQLError['message']
) => {
    const graphqlError = new GraphQLError(errorMessage);

    return graphql.mutation<SigninUserMutation>('signinUser', (_, res, ctx) => {
        return res(ctx.errors([graphqlError]));
    });
};

export const defaultSignInHandler = generateSignInHandler({
    success: true,
    errorMessage: null,
    errorCode: null
});

export const signInPasswordErrorHandler = generateSignInHandler({
    success: false,
    errorCode: 'PASSWORD',
    errorMessage: '<error message>'
});

export const signInMinimalErrorHandler = generateSignInHandler({
    success: false,
    errorCode: null,
    errorMessage: null
});

export const signInServerErrorHandler =
    generateSignInErrorHandler('Arbitrary error');

export const defaultSignInUser = generateUserHandler({
    loggedIn: true,
    name: '<test-name>',
    email: '<test-email>',
    status: 'valid',
    senderPropertyStatus: '',
    userId: 32503316,
    userUuid: '<user-id>',
    creationDate: '2020-01-26 11:34:01',
    brandPrimary: 'zoopla',
    registrationSources: ['ZPG'],
    registered: true
});
